import { useOrgContext } from '@/org/contexts/OrgContext'
import { HStack } from '@chakra-ui/react'
import { Meeting_Step_Type_Enum } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { meetingStepAids } from '../meetingStepAids'
import MeetingStepAidButton from './MeetingStepAidButton'

interface Props {
  type: Meeting_Step_Type_Enum
}

// The aids of a meeting step, next to its title (#136)
export default function MeetingStepAids({ type }: Props) {
  const { t } = useTranslation()
  const { org } = useOrgContext()
  const roles = meetingStepAids[type]
  // An org may turn every aid off in its settings (#136)
  if (org?.meetingAidsEnabled === false || !roles?.length) return null

  return (
    <HStack spacing={2} ml={4}>
      {roles.map((role) => (
        <MeetingStepAidButton
          key={role}
          role={role}
          // Keys built at runtime: typed as any, each one exists in fr and en
          // (checked by meetingStepAidsI18n.test.ts)
          text={t(`MeetingStepAids.${type}.${role}` as any)}
        />
      ))}
    </HStack>
  )
}
